import React from 'react'
import '../C_Topics/Intro.css'
const Jva_BCC = () => {
    return (
        <div>
              <div>
               <div class="about">
            <div class="container">
                <h2 class="h1 text-center">Six Basic Computer Components</h2>
                <p class="responsive-paragraph"></p>
                  <ol>
                      <li><h3>Reading/Recieving</h3></li>
                      <p>When a computer is required to receive information or input from a particular source,
                           whether it be a terminal, a disk or any other device, the verbs Read, Input and Get 
                           are used in Pseudocode. Read is usually used when the algorithm is to receive input
                            from a record on a file, while Get, Input are used when the algorithm is used to receive input from the keyboard.
                            <br /> <strong>For example</strong>, typical Pseudocode
instructions to receive information are :

<pre>
<mark>Read</mark> student name <br />
<mark>Get</mark> system date <br />
<mark>Read</mark> number-1, number-2 <br />
<mark>Get</mark> tax-code <br />
<mark>Input</mark> marks <br />
</pre>
(Highlighted words are keywords).
<br />
Each example uses a single verb, Read or Get followed by one or more nouns to indicate what data is to be obtained. At no stage is necessary to specify the source of the data, as this information is not required until run time.</p>
                      <li><h3>Output/Printing</h3></li>
                      <p>When a computer is required to supply information or output to a device, the verbs Print, Write, Put, Output or Display are used in Pseudocode. Print is usually used when the output is to be sent to the printer
                          , while write is used when the output is to be written to a file. If the output is written to the screen, the words put, output or display are used in Pseudocode.
                          <br /> <strong>Typical Pseudocode examples are -</strong><br /> 
<pre>
<mark>Print</mark> 'Program completed' <br />
<mark>Write</mark> customer record to master file <br />
<mark>Put </mark>out name, address and postcode <br />
<mark>Output</mark> total-tax <br />
<mark>Display </mark>'End of data' <br />
</pre>
In each example, the data to be output is described concisely using mostly lower-case letters.</p>
                      <li><h3>Performing arithm</h3>etic opertaion</li>
                      <p>Most programs require the computer to perform some sort of mathematical calculation or formula and for these a programmer may use either actual mathematical symbols or the words for those symbols. <br /> For instance, the same Pseudocode instruction can be expressed as either of the following: <br />
<pre>
Add number to total: <br />

         Total = total + number
</pre>
Both expressions clearly instructs the computer to add one value to another so either is acceptable in Pseudocode. The equal symbol <strong>‘=’</strong> has been used to indicate assignment of a value as a result of some processing. <br />

To be consistent with high-level programming languages, the following symbols can be written in Pseudocode : <br/>
<pre>
                +            <mark>Add</mark> <br />
    -                <mark> Subtract</mark><br />
    *            <mark>Multiply</mark><br />
    /            <mark> Divide</mark><br />
   ( )          <mark>Parentheses</mark><br />
   </pre>
The verbs <mark>Compute</mark> and <mark>Calculate</mark> are also available. Some Pseudocode examples to perform a calculation are: <br />

<mark>Divide</mark> total – marks by student-count <br />
Sales – tax = cost – price * 0.10 <br />
<mark>Compute</mark> C = (F - 32) * 5/9 <br />


When writing mathematical calculations for the computer, the ‘order of operations’ common to all programming languages, should be considered. The first operation carried out will be any calculation contained within parentheses. Next, any multiplication or division as it occurs from left to right, will be performed. Then any addition or subtraction, as it occurs from left to right, will be performed.</p>
                      <li><h3>Assigning Value to a Variable</h3></li>
                      <p>There are three cases where you may write Pseudocode to assign a value to a variable or memory location: <br />
<ol>
<li> To give data an initial value in Pseudocode, the verbs <mark>Initialize</mark> or <mark>Set</mark> are used.</li>
<li>To assign a value as a result of some processing, the symbol <mark>‘=’</mark> is written</li>
<li>To keep a piece of information for later use, the verbs <mark>Save</mark> or <mark>Store</mark> is used </li>
</ol>
<pre>
Some typical Pseudocode examples are: <br />

<mark>Initialize</mark> total accumulators to zero <br />
<mark>Set</mark> student - count to 0 <br />
Total - price = cost - price + soles - tax <br />
<mark>Store</mark> customer - num in lost - customer - num <br />
</pre></p>
                      <li><h3>Conditional Execution</h3></li>
                      <p>An important computer operation available to programmer is the 
                          ability to compare two variables and then, as a result of the comparison,
                           select one of two alternative actions. To represent this operation in 
                           Pseudocode, special keywords are used: <mark> IF</mark>,<mark> THEN</mark> and<mark> ELSE</mark>. 
                           The comparison of data is established in the If clause, and the 
                           choice of alternatives is determined by the Then or Else options. 
                           Only one of these alternatives will be performed.
                            A typical Pseudocode example to illustrate this operation is : <br />
<pre>
<mark>IF</mark> student is part-time <mark>THEN </mark><br />
    add 1 to part-time count <br />
    <mark>ELSE</mark> <br />
    add 1 to full-time count <br />
    <mark>ENDIF</mark><br />
</pre>


In this example the attendance status of the student is investigated, with the result that either the part time count or the full time count
 accumulator is incremented. Note the use of indentation to emphasize the <mark>Then</mark> and <mark>Else</mark> options, and the use of the delimiter ENDIF to close the operation.</p>
   <li><h3>Repeat a group of Action</h3></li>
   <p>When there is a sequence of processing tips, which need to be repeated, two special keywords, <mark> DO WHILE </mark>and<mark> END DO</mark> are used in Pseudocode. The condition 
   for the repletion of a group of actions is established in the Do While clause, and the actions to be repeated are listed beneath it. <br />
    For example: <br />

    <mark>DO WHILE</mark> student-total &lt; n <br />
    Read Student record <br />
    Print student name address to report <br />
    Add 1 to student-total <br />
    <mark>END DO</mark> <br />


In this example it is easy to see the statements which are to be repeated, as they immediately follow the<mark>DO WHILE</mark> statement and are intended for added emphasis. The condition
 which controls and eventually terminates the repetition is established in the <mark> DO WHILE</mark> clause, and the keyword <mark>END DO</mark> acts as delimiter. As soon as the condition
  for repetition is found to be false, control passes to the next statement after the <mark>END DO </mark>.</p>
                  </ol>
            </div>
            </div>
        </div>
        </div>
    )
}

export default Jva_BCC
